/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
import { useEffect, useState } from 'react';
import { rem } from './polishedUtil.js';

function getCurrentFont() {
  const root = document.querySelector(':root');
  if (!root) return 13;
  const fontSize = window.getComputedStyle(root).getPropertyValue('font-size');
  if (!fontSize) return 13;
  // @ts-expect-error - file used to be like this, mobile is deprecated, just leaving as is
  return Number(fontSize.match(/\d+/)[0]);
}

// @ts-expect-error - file used to be like this, mobile is deprecated, just leaving as is
export function useHeight(ref) {
  const [height, setHeight] = useState('0rem');
  const [currentFont, setCurrentFont] = useState(13);
  useEffect(() => {
    setCurrentFont(getCurrentFont());
  }, []);

  useEffect(() => {
    if (ref.current && height !== rem(ref.current.clientHeight, currentFont)) {
      setHeight(rem(ref.current.clientHeight, currentFont));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ref.current, currentFont]);

  return height;
}
